var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransmission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35,44h-6c-.2729,0-.5342-.1118-.7231-.3091-.1885-.1973-.2881-.4634-.2759-.7363l1-22c.0244-.5342,.4644-.9546,.999-.9546h4c.5347,0,.9746,.4204,.999,.9546l1,22c.0122,.2729-.0874,.5391-.2759,.7363-.189,.1973-.4502,.3091-.7231,.3091Zm-4.9536-2h3.9072l-.9092-20h-2.0889l-.9092,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,48H23c-.5522,0-1-.4478-1-1v-4c0-.5522,.4478-1,1-1h18c.5522,0,1,.4478,1,1v4c0,.5522-.4478,1-1,1Zm-17-2h16v-2H24v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,52H21c-.5522,0-1-.4478-1-1v-4c0-.5522,.4478-1,1-1h22c.5522,0,1,.4478,1,1v4c0,.5522-.4478,1-1,1Zm-21-2h20v-2H22v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,56H19c-.5522,0-1-.4478-1-1v-4c0-.5522,.4478-1,1-1h26c.5522,0,1,.4478,1,1v4c0,.5522-.4478,1-1,1Zm-25-2h24v-2H20v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,60H17c-.5522,0-1-.4478-1-1v-4c0-.5522,.4478-1,1-1h30c.5522,0,1,.4478,1,1v4c0,.5522-.4478,1-1,1Zm-29-2h28v-2H18v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7631,5c-.0056,.0266-.0219,.0479-.0253,.0752l-.6196,4.9248h-2.2363l-.6196-4.9248c-.0034-.0274-.0198-.0486-.0253-.0752h-1.9349c-.0219,.1052-.0383,.2127-.0242,.3252l.73,5.7998c.063,.5,.4883,.875,.9922,.875h4c.5039,0,.9292-.375,.9922-.875l.73-5.7998c.0142-.1125-.0023-.22-.0242-.3252h-1.9349Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2344,22h-6.4688c-1.5098,0-2.7896-1.1299-2.9766-2.6279l-1.0786-8.6279c-.2134-1.707,.3169-3.4253,1.4556-4.7148,1.1382-1.2896,2.7778-2.0293,4.498-2.0293h2.6719c1.7202,0,3.3599,.7397,4.498,2.0293,1.1387,1.2896,1.6689,3.0078,1.4556,4.7148l-1.0786,8.6279c-.187,1.498-1.4668,2.6279-2.9766,2.6279ZM30.6641,6c-1.147,0-2.2397,.4932-2.999,1.3525-.7588,.8599-1.1123,2.0054-.9702,3.1436l1.0786,8.6279c.0625,.4995,.4888,.876,.9922,.876h6.4688c.5034,0,.9297-.3765,.9922-.876l1.0786-8.6279c.1421-1.1382-.2114-2.2837-.9702-3.1436-.7593-.8594-1.8521-1.3525-2.999-1.3525h-2.6719Z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "a`"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "aa"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "ab"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "ac"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "ad"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "ae"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "af"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransmission);
export default __webpack_public_path__ + "static/media/Transmission.368be58965df346b2bdb11217455b6bb.svg";
export { ForwardRef as ReactComponent };